export const sh_code = [
    { text: '0201 – 0210 Viande et abats comestibles', value: '2' },
    {
        text: '0301 – 0307 Poissons et crustacés, mollusques et autres invertébrés aquatiques',
        value: '3'
    },
    {
        text: '0401 – 0410 Produits laitiers ; œufs d’oiseaux ; miel naturel ; produits comestibles d’origine animale, non dénommés ni compris ailleurs.',
        value: '4'
    },
    {
        text: '0501 – 0511 Produits d’origine animale, non dénommés ni compris ailleurs',
        value: '5'
    },
    {
        text: '0601 – 0604 Arbres et autres plantes vivants ; bulbes, racines et similaires ; fleurs coupées et feuillages ornementaux',
        value: '6'
    },
    {
        text: '0701 – 0714 Légumes comestibles et certaines racines et tubercules',
        value: '7'
    },
    {
        text: '0801 – 0814 Fruits comestibles et noix ; écorces d’agrumes ou de melons',
        value: '8'
    },
    { text: '0901 – 0910 Café, thé, maté et épices', value: '9' },
    { text: '1001 – 1008 Céréales', value: '10' },
    {
        text: '1101 – 1109 Produits de l’industrie meunière ; malt ; amidons ; inuline ; gluten de blé',
        value: '11'
    },
    {
        text: '1201 – 1214 Graines et fruits oléagineux ; céréales, graines et fruits divers ; plantes industrielles ou médicinales ; paille et fourrage',
        value: '12'
    },
    {
        text: '1301 – 1302 Lac ; gommes, résines et autres sucs et extraits végétaux',
        value: '13'
    },
    {
        text: '1401 – 1404 Matières à tresser végétales ; produits végétaux non dénommés ni compris ailleurs',
        value: '14'
    },
    {
        text: '1501 – 1522 Graisses et huiles animales ou végétales et leurs produits de dissociation ; graisses alimentaires préparées ; cires animales ou végétales',
        value: '15'
    },
    {
        text: '1601 – 1605 Préparations de viande, de poisson ou de crustacés, mollusques ou autres invertébrés aquatiques',
        value: '16'
    },
    { text: '1701 – 1704 Sucres et sucreries', value: '17' },
    {
        text: '1801 – 1806 Cacao et préparations à base de cacao',
        value: '18'
    },
    {
        text: '1901 – 1905 Préparations de céréales, de farine, d’amidon ou de lait ; produits de la pâtisserie',
        value: '19'
    },
    {
        text: '2001 – 2009 Préparations de légumes, de fruits, de noix ou d’autres parties de plantes',
        value: '20'
    },
    {
        text: '2101 – 2106 Préparations comestibles diverses',
        value: '21'
    },
    { text: '2201 – 2209 Boissons, alcools et vinaigres', value: '22' },
    {
        text: '2301 – 2309 Résidus et déchets des industries alimentaires ; fourrage préparé pour les animaux',
        value: '23'
    },
    {
        text: '2401 – 2403 Tabac et substituts du tabac manufacturé',
        value: '24'
    },
    {
        text: '2501 – 2530 Sel ; soufre ; terres et pierres ; matériaux de plâtrage, chaux et ciment',
        value: '25'
    },
    { text: '2601 – 2621 Minerais, scories et cendres', value: '26' },
    {
        text: '2701 – 2715 Combustibles minéraux, huiles minérales et produits de leur distillation ; matières bitumineuses ; cires minérales',
        value: '27'
    },
    {
        text: '2801 – 2853 Produits chimiques inorganiques ; composés organiques ou inorganiques de métaux précieux, de métaux des terres rares, d’éléments radioactifs ou d’isotopes',
        value: '28'
    },
    { text: '2901 – 2942 Produits chimiques organiques', value: '29' },
    { text: '3001 – 3006 Produits pharmaceutiques', value: '30' },
    { text: '3101 – 3105 Engrais', value: '31' },
    {
        text: '3201 – 3215 Extraits tannants ou tinctoriaux ; tanins et leurs dérivés ; teintures, pigments et autres matières colorantes ; peintures et vernis ; mastics ; encres.',
        value: '32'
    },
    {
        text: '3301 – 3307 Huiles essentielles et résinoïdes ; produits de parfumerie, de cosmétique ou de toilette',
        value: '33'
    },
    {
        text: '3401 – 3407 Savons, agents de surface organiques, préparations pour lessives, préparations lubrifiantes, cires artificielles, cires préparées, préparations pour le polissage ou le récurage, bougies et articles similaires, pâtes à modeler, « cires pour l’art dentaire » et préparations pour l’art dentaire à base de plâtre.',
        value: '34'
    },
    {
        text: '3501 – 3507 Substances albuminoïdes ; amidons modifiés ; colles ; enzymes',
        value: '35'
    },
    {
        text: '3601 – 3606 Explosifs ; produits pyrotechniques ; allumettes ; alliages pyrophoriques ; certaines préparations combustibles',
        value: '36'
    },
    {
        text: '3701 – 3707 Produits photographiques ou cinématographiques',
        value: '37'
    },
    { text: '3801 – 3825 Produits chimiques divers', value: '38' },
    {
        text: '3901 – 3926 Matières plastiques et articles en ces matières',
        value: '39'
    },
    {
        text: '4001 – 4017 Caoutchouc et articles en caoutchouc',
        value: '40'
    },
    {
        text: '4101 – 4115 Cuirs et peaux bruts (autres que les pelleteries) et cuir',
        value: '41'
    },
    {
        text: '4201 – 4206 Articles en cuir ; articles de bourrellerie et de sellerie ; articles de voyage, sacs à main et contenants similaires ; articles en boyaux d’animaux (autres que les boyaux de vers à soie)',
        value: '42'
    },
    {
        text: '4301 – 4304 Peaux de fourrure et fourrures artificielles ; produits manufacturés en ces matières',
        value: '43'
    },
    {
        text: '4401 – 4421 Bois et ouvrages en bois ; charbon de bois',
        value: '44'
    },
    { text: '4501 – 4504 Liège et articles en liège', value: '45' },
    {
        text: '4601 – 4602 Ouvrages en paille, en alfa ou en autres matières à tresser ; vannerie et sparterie',
        value: '46'
    },
    {
        text: '4701 – 4707 Pâtes de bois ou d’autres matières fibreuses cellulosiques ; déchets et rebuts de papier ou de carton',
        value: '47'
    },
    {
        text: '4801 – 4823 Papier et carton ; ouvrages en pâte à papier, en papier ou en carton',
        value: '48'
    },
    {
        text: '4901 – 4911 Printed books, newspapers, pictures and other products of the printing industry; manuscripts, typescripts and plans',
        value: '49'
    },
    { text: '5001 – 5007 Soie', value: '50' },
    {
        text: '5101 – 5113 Laine, poils fins ou grossiers ; fils et tissus de crin de cheval',
        value: '51'
    },
    { text: '5201 – 5212 Coton', value: '52' },
    {
        text: '5301 – 5311 Autres fibres textiles végétales ; fils de papier et tissus de fils de papier',
        value: '53'
    },
    {
        text: '5401 – 5408 Fils à coudre de filaments synthétiques ou artificiels, même conditionnés pour la vente au détail',
        value: '54'
    },
    { text: '5501 – 5516 Fibres synthétiques discontinues', value: '55' },
    {
        text: '5601 – 5609 Ouates, feutres et non-tissés ; fils spéciaux ; ficelles, cordes et cordages ; articles en ces matières',
        value: '56'
    },
    {
        text: '5701 – 5705 Tapis et autres revêtements de sol textiles',
        value: '57'
    },
    {
        text: '5801 – 5811 Tissus spéciaux ; tissus touffetés ; dentelles ; tapisseries ; passementeries ; broderies',
        value: '58'
    },
    {
        text: '5901 – 5911 Tissus imprégnés, enduits, recouverts ou stratifiés ; articles textiles des types utilisés pour l’industrie',
        value: '59'
    },
    { text: '6001 – 6006 Tissus tricotés ou crochetés', value: '60' },
    {
        text: '6101 – 6117 Articles d’habillement et accessoires du vêtement, en tricot ou en bonneterie',
        value: '61'
    },
    {
        text: '6201 – 6217 Articles d’habillement et accessoires du vêtement, autres qu’en bonneterie',
        value: '62'
    },
    {
        text: '6301 – 6310 Autres articles textiles confectionnés ; assortiments ; vêtements et articles textiles usagés ; chiffons',
        value: '63'
    },
    {
        text: '6401 – 6406 Chaussures, guêtres et articles similaires ; parties de ces articles',
        value: '64'
    },
    { text: '6501 – 6507 Couvre-chefs et leurs parties', value: '65' },
    {
        text: '6601 – 6603 Parapluies, ombrelles, parasols, cannes, cannes-sièges, fouets, cravaches et leurs parties',
        value: '66'
    },
    {
        text: '6701 – 6704 Plumes et duvet apprêtés et articles en plumes ou en duvet ; fleurs artificielles ; articles en cheveux humains',
        value: '67'
    },
    {
        text: '6801 – 6815 Articles en pierre, plâtre, ciment, amiante, mica ou matériaux similaires',
        value: '68'
    },
    { text: '6901 – 6914 Produits céramiques', value: '69' },
    { text: '7001 – 7020 Verre et verrerie', value: '70' },
    {
        text: '7101 – 7118 Perles naturelles ou de culture, pierres précieuses ou semi-précieuses, métaux précieux, plaqués ou doublés de métaux précieux et ouvrages en ces matières ; bijouterie de fantaisie ; pièces de monnaie',
        value: '71'
    },
    { text: '7201 – 7229 Fer et acier', value: '72' },
    { text: '7301 – 7326 Articles en fer ou en acier', value: '73' },
    { text: '7401 – 7419 Cuivre et articles en cuivre', value: '74' },
    { text: '7501 – 7508 Nickel et articles en nickel', value: '75' },
    {
        text: '7601 – 7616 Aluminium et articles en aluminium',
        value: '76'
    },
    { text: '7801 – 7806 Plomb et articles en plomb', value: '78' },
    { text: '7901 – 7907 Zinc et articles en zinc', value: '79' },
    { text: '8001 – 8007 Étain et articles en étain', value: '80' },
    {
        text: '8101 – 8113 Autres métaux communs ; cermets ; ouvrages en ces matières',
        value: '81'
    },
    {
        text: '8201 – 8215 Outils, ustensiles, couverts de table, cuillères et fourchettes, en métaux communs ; parties de ceux-ci en métaux communs',
        value: '82'
    },
    {
        text: '8301 – 8311 Articles divers en métaux communs',
        value: '83'
    },
    {
        text: '8401 – 8487 Réacteurs nucléaires, chaudières, machines et appareils mécaniques ; parties de ceux-ci',
        value: '84'
    },
    {
        text: '8501 – 8548 Machines et appareils électriques et leurs parties ; enregistreurs et reproducteurs de son, enregistreurs et reproducteurs d’images et de son de télévision, et parties et accessoires de ces articles',
        value: '85'
    },
    {
        text: '8601 – 8609 Locomotives, matériel roulant et leurs parties ; matériel fixe de voies ferrées ou similaires et leurs parties ; appareils mécaniques (y compris électromécaniques) de signalisation de tout genre.',
        value: '86'
    },
    {
        text: '8701 – 8716 Véhicules autres que le matériel roulant des chemins de fer ou des tramways, et leurs parties et accessoires',
        value: '87'
    },
    {
        text: '8801 – 8805 Aéronefs, véhicules spatiaux et leurs pièces',
        value: '88'
    },
    {
        text: '8901 – 8908 Navires, bateaux et structures flottantes',
        value: '89'
    },
    {
        text: '9001 – 9033 Instruments et appareils d’optique, de photographie, de cinématographie, de mesure, de contrôle, de précision, de médecine ou de chirurgie ; parties et accessoires de ces instruments et appareils.',
        value: '90'
    },
    {
        text: '9101 – 9114 Horloges et montres et leurs parties',
        value: '91'
    },
    {
        text: '9201 – 9209 Instruments de musique ; parties et accessoires de ces articles',
        value: '92'
    },
    {
        text: '9301 – 9307 Armes et munitions ; parties et accessoires de celles-ci',
        value: '93'
    },
    {
        text: '9401 – 9406 Meubles ; literie, matelas, sommiers, coussins et articles similaires rembourrés ; lampes et appareils d’éclairage, non dénommés ni compris ailleurs ; enseignes lumineuses, plaques indicatrices lumineuses et articles similaires ; bâtiments préfabriqués.',
        value: '94'
    },
    {
        text: '9501 – 9508 Jouets, jeux et articles de sport ; parties et accessoires de ceux-ci',
        value: '95'
    },
    { text: '9601 – 9618 Articles manufacturés divers', value: '96' },
    {
        text: '9701 – 9706 Œuvres d’art, pièces de collection et antiquités',
        value: '97'
    }
]